// extracted by mini-css-extract-plugin
export var backButton = "loquLe9YLeJCsFgAHuXq";
export var children = "CGI_4BIzhOJBaRPGuuQF";
export var header = "yQiZ5UMsnkHTA6lsMfCK";
export var heading = "SAKpiKv3j_I5Mwwgowaj";
export var root = "WG4ZxofZHlejs6RfALGE";